// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Common, color } from '@stockbit/ui';
import If from 'global/ErrorHandlers/If';
import Link from 'next/link';
import {
  CustomConfigNavigation,
  CustomNavigationItem,
  NavigationHeader,
} from '../styled';

const { Text, Flex, Iconmoon } = Common;

export interface NavItem {
  label: string;
  value: string;
  icon: string;
  iconSVG?: React.ComponentType<{ isActive?: boolean }>;
  url: string;
}

interface NavigationProps {
  iconClass?: string;
  activeNav?: string;
  items: NavItem[];
  title: string;
  prefixUrl?: string;
  onNavItemClick?(navItem: NavItem): void;
}

function Navigation({
  iconClass = '',
  activeNav,
  items,
  title,
  prefixUrl = '/profile/edit',
  onNavItemClick = () => {},
}: NavigationProps) {
  return (
    <>
      <NavigationHeader>
        <Flex align="center">
          <If condition={iconClass}>
            <Iconmoon
              className={iconClass}
              size="27px"
              style={{ marginRight: 12 }}
              color={color.highempahis}
            />
          </If>
          <Text family="bold" align="center" size="16px">
            {title}
          </Text>
        </Flex>
      </NavigationHeader>

      <CustomConfigNavigation>
        {items.map((nav) => {
          const isActive = nav.url.slice(1) === activeNav;
          return (
            <Link key={nav.value} href={`${prefixUrl}${nav.url}`}>
              <CustomNavigationItem
                onClick={() => onNavItemClick(nav)}
                className="menu"
                key={nav.value}
                isActive={isActive}
                data-cy="setting-index-navigation-item"
              >
                <Text align="left">{nav.label}</Text>
                <Flex
                  width="18px"
                  height="18px"
                  align="center"
                  justify="center"
                >
                  {' '}
                  {nav.iconSVG ? (
                    <nav.iconSVG isActive={isActive} />
                  ) : (
                    <Iconmoon
                      className={`${nav.icon}`}
                      size="14px"
                      style={{
                        color: isActive ? color.primary : color.highempahis,
                      }}
                    />
                  )}
                </Flex>
              </CustomNavigationItem>
            </Link>
          );
        })}
      </CustomConfigNavigation>
    </>
  );
}

export default Navigation;
